import {AVATAR_COLORS} from './constants';

export const getAvatarInitials = (firstName, lastName) =>
  `${firstName ? firstName.charAt(0) : ''} ${lastName ? lastName.charAt(0) : ''}`;

export const getAvatarBackgroundColor = (firstName, lastName) => {
  const firstCode = firstName ? firstName.charCodeAt(0) : 0;
  const lastCode = lastName ? lastName.charCodeAt(0) : 0;

  return AVATAR_COLORS[`color${((firstCode + lastCode) % 14) + 1}`];
};
